module.exports = __webpack_public_path__ + "img/385.30d6a200.png";